import React from "react";

import { connect } from "react-redux";

import {
  InputType2,
  SelectType2,
  ButtonType7,
  Tooltip,
  SliderType3,
} from "@visualizeroi/vroi-custom-components";
import { calculate_fun } from "../redux/actions/widget";
import CurrencyView from "./CurrencyView";

import { CustomSliderType3 } from "./CustomSlider";

import Inputs from "./partial/Inputs";
import InputField from "./partial/InputField";

const InputsView = (props: any) => {
  const { inputs, variables_details, currency_conversion_rate, currency_sign } =
    props;

  const handleValuesUpdate = (code_ref, round = 0) => {
    let var_value = "";
    if (
      variables_details &&
      variables_details[code_ref] &&
      variables_details[code_ref].representation == "Currency"
    ) {
      var_value = props
        .decorate(
          code_ref,
          (inputs[code_ref] * currency_conversion_rate).toFixed(round)
        )
        .toLocaleString()
        .replace("$", currency_sign);
    } else {
      var_value = props
        .decorate(code_ref, inputs[code_ref].toFixed(round))
        .toLocaleString();
    }
    return var_value;
  };

  const inputs_values = (code_ref) => {
    console.log({ inputs });
    return inputs ? handleValuesUpdate(code_ref) : "0";
  };

  const inputs_un_decorate_values = (code_ref) => {
    return inputs ? inputs[code_ref] : "0";
  };

  const getOptions = (code_ref) => {
    console.log(
      variables_details[code_ref] ? variables_details[code_ref].options : {}
    );
    const enum_options = variables_details[code_ref]
      ? variables_details[code_ref].options
      : [];
    let options = {};

    enum_options.map((option) => {
      options[option.name] = option.value;
    });

    return options;
  };

  const handleChange = (e: any, code_ref: any) => {
    props.calculate_fun(
      e,
      code_ref,
      props.visualizer_input_output_values,
      props.calculate
    );
  };

  return (
    <div className="row">
      <div className="col-md-12">
        <div className="inputs_inner">
          <div className="inputs_header">Diamanti TCO Savings Calculator</div>

          <div className="input_var_section">
            <div className="input_var_label_div">
              <label className="inputs_label pr5">Number of Servers</label>
            </div>

            {/* <InputField
              value={inputs_values("Servers - 4ss5n")}
              handleChange={handleChange}
              code_ref={"Servers - 4ss5n"}
              decimal_places={0}
            /> */}

            <CustomSliderType3
              value={inputs_un_decorate_values("Servers - 4ss5n")}
              step={1}
              min={3}
              max={300}
              prefix={""}
              color="#A2D935"
              backgroundColor="white"
              onChange={(e) => handleChange(e, "Servers - 4ss5n")}
              className="custom_slider"
            />
          </div>

          <div className="input_var_section">
            <div className="input_var_label_div">
              <label className="inputs_label pr5">CPUs per Server</label>
            </div>

            {/* <InputField
              value={inputs_values("Cores Per Server - 4ss5o")}
              handleChange={handleChange}
              code_ref={"Cores Per Server - 4ss5o"}
              decimal_places={0}
            /> */}

            <CustomSliderType3
              value={inputs_un_decorate_values("Cores Per Server - 4ss5o")}
              step={1}
              min={8}
              max={64}
              prefix={""}
              color="#A2D935"
              backgroundColor="white"
              onChange={(e) => handleChange(e, "Cores Per Server - 4ss5o")}
              className="custom_slider"
            />
          </div>

          <div className="input_var_section">
            <div className="input_var_label_div">
              <label className="inputs_label pr5">Storage Capacity (TB)</label>
            </div>

            {/* <InputField
              value={inputs_values("Storage Capacity (TB) - 4ss5y")}
              handleChange={handleChange}
              code_ref={"Storage Capacity (TB) - 4ss5y"}
              decimal_places={0}
            /> */}

            <CustomSliderType3
              value={inputs_un_decorate_values("Storage Capacity (TB) - 4ss5y")}
              step={1}
              min={1}
              max={500}
              prefix={""}
              color="#A2D935"
              backgroundColor="white"
              onChange={(e) => handleChange(e, "Storage Capacity (TB) - 4ss5y")}
              className="custom_slider"
            />
          </div>

          <div className="input_var_section">
            <div className="input_var_label_div">
              <label className="inputs_label pr5">
                Number of Storage Arrays
              </label>
            </div>

            {/* <InputField
              value={inputs_values("Storage Arrays - 4ss62")}
              handleChange={handleChange}
              code_ref={"Storage Arrays - 4ss62"}
              decimal_places={0}
            /> */}

            <CustomSliderType3
              value={inputs_un_decorate_values("Storage Arrays - 4ss62")}
              step={1}
              min={1}
              max={10}
              prefix={""}
              color="#A2D935"
              backgroundColor="white"
              onChange={(e) => handleChange(e, "Storage Arrays - 4ss62")}
              className="custom_slider"
            />
          </div>

          <div className="input_var_section">
            <div className="input_var_label_div">
              <label className="inputs_label pr5">Environment</label>
            </div>

            <SelectType2
              selected={
                inputs ? parseInt(inputs["Current Software 1 - 4ss6k"]) : 0
              }
              options={getOptions("Current Software 1 - 4ss6k")}
              onChange={(e) => {
                handleChange(e, "Current Software 1 - 4ss6k");
              }}
            />
          </div>

          <div className="input_var_section">
            <div className="input_var_label_div">
              <label className="inputs_label pr5">Application</label>
            </div>

            <SelectType2
              selected={
                inputs ? parseInt(inputs["Current Software 2 - 4ss6l"]) : 0
              }
              options={getOptions("Current Software 2 - 4ss6l")}
              onChange={(e) => {
                handleChange(e, "Current Software 2 - 4ss6l");
              }}
            />
          </div>

          <div className="input_var_section">
            <div className="input_var_label_div">
              <label className="inputs_label pr5">Term (Years)</label>
            </div>

            <SelectType2
              selected={inputs ? parseInt(inputs["Term - 4ss6w"]) : 0}
              options={getOptions("Term - 4ss6w")}
              onChange={(e) => {
                handleChange(e, "Term - 4ss6w");
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

function mapStateToProps(state, ownProps) {
  const { widget_reducer } = state;
  return {
    ...ownProps,
    visualizer_input_output_values:
      widget_reducer.visualizer_input_output_values,
    inputs: widget_reducer.visualizer_input_output_values
      ? widget_reducer.visualizer_input_output_values.inputs
      : {},
    calculate: widget_reducer.calculate,
    decorate: widget_reducer.decorate,
    variables_details: widget_reducer.visualizer_input_output_details
      ? widget_reducer.visualizer_input_output_details
      : {},
    currency_conversion_rate: widget_reducer.currency_conversion_rate,
    currency_sign: widget_reducer.currency_sign,
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    calculate_fun: (
      event,
      code_ref,
      visualizer_input_output_values,
      calculate
    ) =>
      dispatch(
        calculate_fun(
          event,
          code_ref,
          visualizer_input_output_values,
          calculate
        )
      ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(InputsView);
